import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';
import {StatusEventTypeDescription} from '@constants/machine/status-event-signal/status-event-type-description';
import {
  StatusEventPageEventDisplayDetails
} from '@models/pages/status-event-page/status-event-page-event-display-details';
import {StatusEventPageDataService} from '@services/pages/status-event-page/data/status-event-page-data.service';
import {TranslateService} from '@ngx-translate/core';
import {TranslationService} from '@services/translation/translation.service';

@Component({
    selector: 'scitis-status-event-row',
    templateUrl: './status-event-row.component.html',
    styleUrls: ['./status-event-row.component.scss'],
    standalone: false
})
export class StatusEventRowComponent implements OnInit, OnChanges {

  @Input()
  eventDetails: StatusEventPageEventDisplayDetails = new StatusEventPageEventDisplayDetails('', '', -1, '', StatusEventType.UNDEFINED, '', new Map<string, string>(), new Map<string, string>());
  public isCollapsed = true;
  public metadataKeys: Map<number, string[]> = new Map<number, string[]>();
  public description: string = '';
  private language: string = '';
  private metaDataColumns = 2;

  constructor(private statusEventPageDataService: StatusEventPageDataService,
              private translateService: TranslateService,
              private translationService: TranslationService) {
    this.language = this.translationService.getActiveLanguage();
  }

  public get isFailureEvent(): boolean {
    return StatusEventType.FAILURE === this.eventDetails.type;
  }

  public get isWarningEvent(): boolean {
    return StatusEventType.WARNING === this.eventDetails.type;
  }

  public get isInfoEvent(): boolean {
    return StatusEventType.INFO === this.eventDetails.type;
  }

  public get isDebugEvent(): boolean {
    return StatusEventType.DEBUG === this.eventDetails.type;
  }

  public get isInhibitEvent(): boolean {
    return StatusEventType.INHIBIT === this.eventDetails.type;
  }

  public get statusDescription(): string {
    switch (this.eventDetails.type) {
      case StatusEventType.FAILURE:
        return this.translateService.instant('Failure');
      case StatusEventType.WARNING:
        return this.translateService.instant('Warning');
      case StatusEventType.INFO:
        return this.translateService.instant('Information');
      case StatusEventType.DEBUG:
        return this.translateService.instant('Debug');
      case StatusEventType.INHIBIT:
        return this.translateService.instant('Inhibit');
      case StatusEventType.UNSUPPORTED:
      case StatusEventType.UNDEFINED:
        return '';
    }
  }

  public get statusClass() {
    switch (this.eventDetails.type) {
      case StatusEventType.FAILURE:
        return StatusEventTypeDescription.FAILURE;
      case StatusEventType.WARNING:
        return StatusEventTypeDescription.WARNING;
      case StatusEventType.INFO:
        return StatusEventTypeDescription.INFO;
      case StatusEventType.DEBUG:
        return StatusEventTypeDescription.DEBUG;
      case StatusEventType.INHIBIT:
        return StatusEventTypeDescription.INHIBIT;
      case StatusEventType.UNSUPPORTED:
        return StatusEventTypeDescription.UNSUPPORTED;
      case StatusEventType.UNDEFINED:
        return StatusEventTypeDescription.UNDEFINED;
    }
  }

  ngOnInit(): void {
    this.translationService.getLanguageChangeEventSubject().subscribe((language: string) => {
      this.language = language;
      this.description = this.statusEventPageDataService.getLocalizedDescriptionOrDefault(language, this.eventDetails);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.eventDetails?.currentValue) {
      return;
    }
    this.metadataKeys = this.statusEventPageDataService.splitMetaDataInColumns(this.metaDataColumns, changes.eventDetails.currentValue);
    this.description = this.statusEventPageDataService.getLocalizedDescriptionOrDefault(this.language, changes.eventDetails.currentValue);
  }

  public formatDate(timestamp: number): string {
    return this.statusEventPageDataService.formatDateTime(timestamp,'shortDate') + ' ' +this.statusEventPageDataService.formatDateTime(timestamp,'mediumTime');
  }
}
